/* eslint-disable no-restricted-syntax */
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { filter, switchMap } from 'rxjs/operators';

import { environment as env } from '@eagle/env';
import { SnackBarService } from '../../../shared/services/snack-bar/snack-bar.service';

@Injectable()
export class AppUpdateService {
  private swPush = inject(SwPush);
  private swUpdate = inject(SwUpdate);
  private snackBarService = inject(SnackBarService);
  private router = inject(Router);

  initUpdates(): void {
    if (!this.swUpdate.isEnabled) {
      console.warn('SW Update is not enabled.');
      return;
    }

    this.swUpdate.versionUpdates
      .pipe(
        filter(event => event.type === 'VERSION_READY'),
        switchMap(() => this.snackBarService.openUpdateVersion()),
        switchMap(updateSnackbarRef => updateSnackbarRef.onAction())
      )
      .subscribe(async () => {
        await this.swUpdate.activateUpdate();
        await this.router.navigateByUrl('/app');
        location.reload();
      });
  }

  initPush(): void {
    if (!this.swPush.isEnabled) {
      console.warn('SW Push is not enabled.');
      return;
    }

    this.swPush
      .requestSubscription({
        serverPublicKey: env.webPush.vapid.publicKey,
      })
      .catch(console.error);

    this.swPush.messages
      .pipe(
        filter((message: any) => message.type === 'UPDATE') // TODO: any and enum
      )
      .subscribe(() => this.swUpdate.checkForUpdate());
  }
}
